import SkyClickPlayer from "../../components/custom/SkyClickPlayer";
import EventManager from "../../communication/EventManager";

import {HookManager} from "../../communication/HookManager";
import hookManagerInstance from "../../communication/HookManager";
import ResolutionSwitcherPluginDecorator from "./ResolutionSwitcherPluginDecorator";
import PlaylistPluginDecorator from "./PlaylistPluginDecorator";

class PluginDecorator {

    /**
     * STATIC OBJECT - once object for all player instances
     */

    static hookManagerInstance:HookManager = hookManagerInstance;

    static readonly PLUGIN_NAME:string;

    // Level 0: run static function
    static bootingStaticApi() {}

    // Level 1: booting instance
    static bootingInstance(skyClickPlayer:SkyClickPlayer){
        return new this(skyClickPlayer);
    }


    /**
     * INSTANCE OBJECT - new object for each player instance
     */

    protected eventManager:EventManager;

    // GETTER to load instantiated decorators
    public get resolutionSwitcherDecorator(){
        return this.skyClickPlayer.pluginManager.getPluginDecorator<ResolutionSwitcherPluginDecorator>('resolution-switcher');
    }
    public get playlistDecorator(){
        return this.skyClickPlayer.pluginManager.getPluginDecorator<PlaylistPluginDecorator>('playlist');
    }

    /**
     * Prepare decorator instance and provide information for other decorators.
     * Do not execute the plugin here. Use this.bootingExecution function to start the plugin
     * @param skyClickPlayer
     */
    constructor(protected skyClickPlayer:SkyClickPlayer){
        this.eventManager = skyClickPlayer.eventManager;
        this.registerSystemEventAliases();
    }

    /**
     * Locate here the startup code for the decorated plugin
     */
    public bootingExecution(){}

    /**
     * Return static plugin name over instance object
     * @returns {string|any}
     */
    get pluginName(){
        return (<any>this).constructor.PLUGIN_NAME;
    }

    /**
     * Alias event for system events
     *
     * @example
     * {
     *      {'systemevent':'aliasevent'}
     * }
     */
    protected get systemEventAliases():Object{
        return {};
    }

    /**
     * Register defined systemEventAliases
     */
    protected registerSystemEventAliases(){
        for (let systemEventName in this.systemEventAliases) {
            let aliasHookName = this.systemEventAliases[systemEventName];
            this.eventManager.registerAlias(systemEventName, aliasHookName);
        }
    }

}

export default PluginDecorator;


// WEBPACK FOOTER //
// ./src/app/plugins/decorators/PluginDecorator.ts